<template>
    <div class="position-relative">
        <input v-model="searchInput" type="text" 
        class="form-control border border-2 border-primary"
        style="--bs-border-opacity: .5;"
        placeholder="Chercher...">
        <font-awesome-icon class="position-absolute top-50 start-100 translate-middle pe-5 text-muted" :icon="['fas', 'fa-magnifying-glass']" size="l" />
    </div>
</template>

<script>
export default {
    props: ['searchFunction'],
    data() {
        return {
            searchInput: null
        };
    },
    watch: { 
        searchInput: function() {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.$emit(this.searchFunction, this.searchInput);
            }, 400);
        }
    }
}
</script>